<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div><img class="center-svg" src="assets/svg/contact-icon.svg" alt=""></div>
      <div><h4 class="text-semibold">{{data.mode === 'edit' ? "Modificar informaci&oacute;n Contacto" : "Nuevo contacto"}}</h4><h6 class="color-gray" style="font-weight: 400;">{{data.mode === 'edit' ? "Completa los datos que necesitas modificar del contacto" : "Completa los datos para registrar un nuevo contacto"}}</h6></div>
      <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
    </div>
    <div class="mdl-body">
      <h5 class="text-semibold mt-4">Información del contacto</h5>
      <form #ContactForm="ngForm" (ngSubmit)="$event.preventDefault()">
      <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
        <div>
          <div class="mt-3">
            <label class="login-label" for="nombre_empresa"><span class="required-asterisk" *ngIf="!cuentaSeleccionada|| cuentaSeleccionada.trim() === ''">*</span> Nombre de la cuenta:</label>
            <div class="input-bordered">
              <div class="d-grid crm-ng-select" >
                <div><img style="width: 30px;" src="assets/svg/account.svg" alt="icono asignado"></div>
                <div>
                  <ng-select
                    *ngIf="cuentas"
                    name="cuenta_id"
                    required
                    [items]="cuentas"
                    bindLabel="nombre_empresa"
                    bindValue="cuenta_id"
                    placeholder="Seleccionar cuenta..."
                    [(ngModel)]="cuentaSeleccionada"
                    [searchable]="true"
                    [clearable]="false"
                    >
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
          

          <div class="mt-3">
            <label class="login-label" for="nombres">
              <span class="required-asterisk" *ngIf="!request.nombre|| request.nombre.trim() === ''">*</span> 
              Nombres:
            </label>
            <input 
            class="crm-input" 
            type="text" 
            name="nombres" 
            id="nombres" 
            [(ngModel)]="request.nombre"
            required
            #nameCtrl="ngModel"
             placeholder="María José" />
             <div class="error-text" *ngIf="nameCtrl.invalid && (nameCtrl.dirty || nameCtrl.touched)">
              <small *ngIf="nameCtrl.errors?.['required']">El campo nombres es obligatorio.</small>
             </div>
          </div>

          <div class="mt-3">
            <label class="login-label" for="tratamiento">Tratamiento:</label>
            <select class="crm-input" name="tratamiento" id="tratamiento" [(ngModel)]="request.tratamiento">
              <option value="" disabled selected>-- Ninguno --</option>
              <option value="Sr.">Sr.</option>
              <option value="Sra.">Sra.</option>
              <option value="Srta.">Srta.</option>
            </select>
          </div>

          <div class="mt-3">
            <label class="login-label" for="telefono">Teléfono:</label>
            <input class="crm-input" type="text" name="telefono" id="telefono" [(ngModel)]="request.telefono" placeholder="+56 2 2134 5678" maxlength="12" />
          </div>

          <div class="mt-3">
            <label class="login-label" for="correo">Correo:</label>
            <input class="crm-input" type="email" name="correo" id="correo" [(ngModel)]="request.email" placeholder="example@gmail.com" />
          </div>
        </div>

        <div>
          <div class="mt-3">
          <label class="login-label">Propietario del contacto:</label>
          <div class="d-flex flex-row align-items-center color-org gap-10">
            <img src="assets/svg/avatar.svg" alt="">
            <b><u>
              {{ data.mode === 'edit'
                  ? (contacto?.ejecutivo?.nombre + ' ' + contacto?.ejecutivo?.apellido || loggedUserName)
                  : loggedUserName
              }}
            </u></b>
          </div>
        </div>

          <div class="mt-3">
            <label class="login-label" for="apellidos">
              <span class="required-asterisk" *ngIf="!request.apellido|| request.apellido.trim() === ''">*</span>
              Apellidos:
            </label>
            <input 
            class="crm-input" 
            type="text" 
            name="apellidos" 
            id="apellidos" 
            [(ngModel)]="request.apellido"
            required
            #apellidoCtrl="ngModel"
            placeholder="Ramírez Pérez" />
            <div class="error-text" *ngIf="apellidoCtrl.invalid && (apellidoCtrl.dirty || apellidoCtrl.touched)">
              <small *ngIf="apellidoCtrl.errors?.['required']">El campo apellidos es obligatorio.</small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label" for="cargo">
              <span class="required-asterisk" *ngIf="!request.cargo|| request.cargo.trim() === ''">*</span> 
              Cargo:
            </label>
            <input 
            class="crm-input" 
            type="text" 
            name="cargo" 
            id="cargo" 
            [(ngModel)]="request.cargo" 
            required
            #cargoCtrl="ngModel"
            placeholder="Ejecutivo comercial" />
            <div class="error-text" *ngIf="cargoCtrl.invalid && (cargoCtrl.dirty || cargoCtrl.touched)">
              <small *ngIf="cargoCtrl.errors?.['required']">El campo cargo es obligatorio.</small>
            </div>
          </div>

          <div class="mt-3">
            <label class="login-label" for="celular">Celular:</label>
            <input class="crm-input" type="text" name="celular" id="celular" [(ngModel)]="request.celular" placeholder="+56 9 1234 5678" maxlength="12"/>
          </div>

          <div class="mt-3">
            <label class="login-label" for="linkedin">LinkedIn:</label>
            <input class="crm-input" type="text" name="linkedin" id="linkedin" [(ngModel)]="request.linkedin" placeholder="María José Ramírez" />
          </div>
        </div>
      </div>

      <h5 class="text-semibold mt-4">Información adicional</h5>
      <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
        <div>
          <div class="mt-3">
            <label for="fecha_nacimiento" class="login-label">Fecha de nacimiento:</label>
            <input class="crm-input" type="date" name="fecha_nacimiento" id="fecha_nacimiento" [(ngModel)]="request.fecha_nacimiento" />
          </div>
          <div class="mt-3">
            <label for="hobbie" class="login-label">Hobbie:</label>
            <input class="crm-input" id="hobbie" name="hobbie" [(ngModel)]="request.hobbie" placeholder="Agrega los hobbies del contacto (opcional)." rows="1">
          </div>
        </div>
        <div>
          <div class="mt-3">
            <label for="aniversario_empresa" class="login-label">Aniversario de la empresa:</label>
            <input class="crm-input" type="date" name="aniversario_empresa" id="aniversario_empresa" [(ngModel)]="request.aniversario_empresa" />
          </div>
          <div class="mt-3">
            <label for="genero" class="login-label">Identidad de género:</label>
            <select class="crm-input" name="genero" id="genero" [(ngModel)]="request.identidad_genero">
              <option value="" disabled selected>Selecciona identidad de género</option>
              <option value="Femenino">Femenino</option>
              <option value="Masculino">Masculino</option>
              <option value="Otro">Otro</option>
            </select>
          </div>
        </div>
      </div>

      <h5 class="text-semibold mt-4">Dirección de envío</h5>
      <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
        <div>
          <div class="mt-3">
            <label for="calle" class="login-label">Calle:</label>
            <input class="crm-input" type="text" name="calle" id="calle" [(ngModel)]="request.calle_env" placeholder="Av. Libertador 1234" />
          </div>
          <div class="mt-3">
            <label class="login-label" for="">Region</label>
            <select class="crm-input" name="region" id="" [(ngModel)]="request.region_env" (change)="getComunas(request.region_env)">
              @for(item of regiones; track item.NombreRegion){
                <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
              }
            </select>
          </div>
        </div>
        <div>
          <div class="mt-3">
            <label class="login-label" for="">Comuna</label>
            <select class="crm-input" name="comuna" id="" [(ngModel)]="request.ciudad_env">
              @for (comuna of comunas; track comuna) {
                <option [value]="comuna">{{ comuna }}</option>
              }
            </select>
          </div>
          <div class="mt-3">
            <label class="login-label" for="">Pa&iacute;s</label>
            <input class="crm-input" type="text" name="pais" id="pais" [value]="contacto?.pais" [(ngModel)]="request.pais" disabled>
          </div>
        </div>
      </div>

      <hr class="mt-5 mb-5">
      <div class="d-flex flex-row justify-center gap-20 mt-2">
        <button type="button" (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
        @if(data.mode === 'edit'){
          <button type="button" class="btn btn-primary text-center" (click)="updateContact();" [disabled]="!ContactForm.valid">Modificar contacto</button>
        }@else{
          <button type="button" class="btn btn-primary text-center" (click)="createContact();" [disabled]="!ContactForm.valid">A&#241;adir nuevo contacto</button>
        }
      </div>
      </form>
    </div>
  </div>
</div>